import React from 'react';
import * as Icons from "../Icons";

export default class AddCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    }
  }
  render() {
    const { onClick, disabled, color, children } = this.props;
    const { hover } = this.state;
    const { rowSpan } = children;
    const td_style = {                // <td> 各セル
      width: 30,
      border: "1px solid #ddd",
      textAlign: "center",
      verticalAlign: "middle",
      paddingTop: 4,
      transition: '0.2s',
      backgroundColor:
        hover ? "#Cf8080" :
          null,
      pointerEvents:
        disabled ? "none" :
          "auto",
      cursor:
        disabled ? null : 'pointer',
    }
    const iconColor = hover ? "#FFFFFF" : "#Cf8080";
    return (
      <td
        style={td_style}
        rowSpan={rowSpan || 1000}
        onClick={onClick}
        tabIndex={!disabled ? 0 : null}
        onMouseOver={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        onFocus={() => this.setState({ hover: true })}
        onBlur={() => this.setState({ hover: false })}
      >
        <Icons.PlusSquare width={16} height={16} color={iconColor} hidden={disabled} />
      </td>     // type指定したもの（コンポーネントなど）
    )
  }
}
